import React from 'react';
import "../../_asset/css/popular_games.css";
import { CasinoList, SlotList, PopularGameList } from "./new_game_list";

export default function MainGameNewListLayout() {
    return (
        <div className={"new-game-list-layout"}>
            <PopularGameList />
            <CasinoList />
            <SlotList />
        </div>
    )
}
